import DuoMascot from '@/components/v2/DuoMascot'
import { useSelectedLanguageName } from '@/hooks/useSelectedLanguageName'
import { useTranslation } from 'react-i18next'
import { Form, useNavigate } from 'react-router-dom'

/**
 * Duolingo's wall between the first lesson and the rest of the app: mascot,
 * "Time to create a profile!", one reason to do it, one button. The award
 * badges the shared page shows are gone — Duolingo makes the ask about the
 * progress you would lose, not about the company.
 *
 * Navigation is unchanged: continue goes to /sign-up/password.
 */
export default function CompanyPage() {
  const language = useSelectedLanguageName()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    navigate('/sign-up/password')
  }

  return (
    <div className="min-h-dvh bg-white">
      <main className="duo-container flex min-h-dvh flex-col pt-6 pb-8">
        <div className="flex grow flex-col items-center justify-center gap-8 text-center">
          <DuoMascot className="h-28 w-28" />

          <div className="space-y-3">
            <h1 className="text-duo-ink text-[26px] leading-tight font-extrabold text-balance">
              {t('pages.signUp.v2.company.title')}
            </h1>

            <p className="text-duo-muted text-[15px] leading-relaxed text-balance">
              {t('pages.signUp.v2.company.subtitle', { language })}
            </p>
          </div>
        </div>

        <Form className="shrink-0" method="post" onSubmit={handleSubmit}>
          <button
            className="duo-button-primary"
            data-testid="button-continue"
            type="submit"
          >
            {t('pages.signUp.v2.company.cta')}
          </button>
        </Form>
      </main>
    </div>
  )
}
